export enum IconColour {
  BLUE = 'blue',
  YELLOW = 'yellow',
  INSIGHTS = 'insights',
}
